import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ShoppingCartState, selectAllShoppingCarts, shoppingCartFeatureKey } from './shopping-cart.reducer';

export const selectShoppingCartState = createFeatureSelector<ShoppingCartState>(shoppingCartFeatureKey);

export const selectShoppingCartsStatus = createSelector(selectShoppingCartState, (state) => state.shoppingCartsStatus);

export const selectShoppingCarts = createSelector(selectShoppingCartState, (state) =>
  selectAllShoppingCarts(state.shoppingCarts),
);
